import { OVEntity, OVField, OVSearch, OVTable } from '@ov-suite/ov-metadata';
import { Rag } from '@ov-suite/helpers-shared';
import { InventoryLocationModel, ProductSkuModel } from '@ov-suite/models-admin';

@OVTable<InventoryLocationCountModel>([
  {
    title: 'Name',
    type: 'deep-string',
    key: 'inventoryLocation.name',
  },
  // {
  //   title: 'Description',
  //   type: 'deep-string',
  //   key: 'inventoryLocation.description',
  // },
  {
    title: 'Count',
    type: 'number',
    key: 'quantity',
  },
  {
    title: 'Product',
    type: 'deep-string',
    key: 'productSku.name',
  },
  {
    title: 'SKU',
    type: 'deep-string',
    key: 'productSku.sku',
  },
  {
    title: 'Status',
    type: 'other',
    action: val => {
      switch (val.rag) {
        case Rag.amber:
          return `<span style="color: orange">●</span>`;
        case Rag.green:
          return `<span style="color: green">●</span>`;
        case Rag.red:
          return `<span style="color: red">●</span>`;
        default:
          return 'missing';
      }
    },
    keys: ['rag', 'inventoryLocation.id'],
    disableSorting: true,
    disableFiltering: true,
  },
])
@OVSearch<InventoryLocationCountModel>({
  searchKeys: ['inventoryLocation.name', 'inventoryLocation.description'],
})
@OVEntity({ name: 'InventoryLocationLevels' })
export class InventoryLocationCountModel {
  @OVField({ type: 'number' })
  id: number;

  @OVField({ type: () => InventoryLocationModel })
  inventoryLocation: InventoryLocationModel;

  @OVField({ type: () => ProductSkuModel })
  productSku: ProductSkuModel;

  @OVField({ type: 'number' })
  quantity: number;

  @OVField({ type: 'date' })
  enterTime: Date;

  @OVField({ type: 'date' })
  exitTime?: Date;

  @OVField({ type: 'number' })
  rag: Rag;
}
